export default __webpack_public_path__ + "static/media/user-profile-icon.9054598b.svg";